module.exports = __webpack_public_path__ + "img/portrait-earbuds.08deb5ca.svg";